import "./index.scss";
import classNames from "classnames";

const P18 = ({ text }: { text: any }) => {
  return (
    <p
      className={classNames("p18")}
      dangerouslySetInnerHTML={{ __html: text }}
    ></p>
  );
};
export default P18;
